export default __webpack_public_path__ + "static/media/rmnt3.b508466b.jpg";